/* tslint:disable */
/* eslint-disable */
/**
 * Communication API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorBadGatewayError {
    'code': CommonErrorBadGatewayErrorCodeEnum;
    'message': string;
}

export enum CommonErrorBadGatewayErrorCodeEnum {
    IntegrationFailure = 'INTEGRATION_FAILURE'
}


